import request from '@/utils/request'
// 首页
// 首页
export function add(data) { // 留资
  return request({
    method: 'POST',
    // headers:{
    //   'Content-Type':'application/x-www-form-urlencoded'
    // },
    url: '/trialPhone/add',
    data
  })
}
export function getIndustryList() { // 留资选项
  return request({
    method: 'GET',
    // headers:{
    //   'Content-Type':'application/x-www-form-urlencoded'
    // },
    url: 'industryMst/getIndustryAllList',
  })
}
export function officialLog(data) { //上报
  return request({
    method: 'POST',

    url: '/official/add',
    data
  })
}

export function selectNewsCategoryList(data) { // 大米咨询 左侧列表分类
  return request({
    method: 'GET',

    url: '/newsDat/selectNewsCategoryList',
    params: data
  })
}
export function addClickCount(data) { // 大米咨询 数据点击数
  return request({
    method: 'GET',

    url: '/newsDat/addClickCount',
    params: data
  })
}
export function selectNewsById(data) { // 大米咨询 课件详情
  return request({
    method: 'GET',

    url: '/newsDat/selectNewsById',
    params: data
  })
}

export function selectNewsPage(data) { // 大米咨询 分页查询的数据
  return request({
    method: 'POST',

    url: '/newsDat/selectNewsPage',
    data
  })
}
export function selectNewsPageOrderByStatus(data) { // 大米咨询 最新 最热
  return request({
    method: 'POST',

    url: '/newsDat/selectNewsPageOrderByStatus',
    data
  })
}
export function list() { // 大米课堂 目录
  return request({
    method: 'POST',

    url: '/officialFileCategory/list',
    data:{}
  })
}

export function getList(data) { // 大米课堂 课件
  return request({
    method: 'POST',

    url: '/officialFile/getList',
    data
  })
}

export function getDetail(data) { // 大米课堂 课件内容
  const form = new FormData()
  for (const key in data) {
    form.append(key, data[key])
  }
  return request({
    method: 'POST',

    url: '/officialFile/getDetail',
    data:form
  })
}
export function getPage(data) { // 大米课堂 目录下课堂视频分页
  return request({
    method: 'POST',

    url: '/officialFile/getPage',
    data
  })
}

